import { gql } from '@apollo/client';

export const ImportStatusQuery = gql`
  query ImportStatusQuery($integration: Integration!) {
    inProgress: importInStatus(integration: $integration)
  }
`;
